export const MAX_DIRECTORY_ENTRIES = 10;
export const ENTRIES_FIELDS = 'items(id,link,name,order,thumbnail),more,callId,cursor';
export const TEMPLATE_PREFIX = 'template-';
